/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */
/*
<div class="form-group pb-3">
    <label for="${name}" class="pb-2 fs-4">${title}</label>
    <div class="input-group">
        <div class="input-group-prepend">
            <div class="input-group-text rounded-0 rounded-start input-icon-block"><i class="${icon}"></i></div>
        </div><input id="${name}" class="form-control is-invalid" title="${title}">
    </div>
</div>
*/

var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.phone",
  title: "Form Group: A phone number",
  description: "A form group with a text box.",
  control: true,
  prevalidate: true,
  supportServer: false,
  fields: {
    "name": {
      title: "Name",
      type: "string",
      description: "The name of the control.",
      required: true
    },
    "title": {
      title: "Title",
      type: "string",
      description: "The title of the control.",
      required: true
    },
    "icon": {
      title: "Icon",
      type: "string",
      description: "The icon of the control.",
      required: false
    },
    "value": {
      title: "Value",
      type: "string",
      description: "The value of the control.",
      required: false
    }, "inputClass": {
      title: "Input Class",
      type: "class",
      description: "The class of the input."
    }, "inputStyle": {
      title: "Input Style",
      type: "style",
      description: "The style of the input."
    }, "description": {
      title: "Description",
      type: "inner",
      description: "The helpful text at the bottom of the control."
    }, "international": {
      title: "International",
      type: "boolean",
      description: "Should I support international numbers? US numbers may be entered invalidly.",
      default: true
    }
  },
  passthrough: {
    except: ["inner", "type", "id", "inputclass", "inputstyle"]
  }
});

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");
var sanitize = require("../../../uam/sanitize.js");

// var define = ; module.exports.define = define;


/**
 * Preparing migration to jsonRender and uae.render();
 * @param {*} options The object to render
 * @returns a ua.code dom element
 */
exports.render = async function (options) {

  var randomName = uai.generateRandomID(12);

  var _input = {
    "n": "input",
    "id": randomName,
    "class": "form-control",
    "title": options.title,
    "type": "tel"
  };

  if ("value" in options) {
    _input.value = options.value;
  }

  /** corrections for quick values for controls */

  try {
    // console.log("*** Opt 1", {
    //   options, _input});

    _input = jsonRender.pass({ ...options }, { ..._input }, ["name", "class", "icon", "style"]);

    // console.log("My new input", myNewInput);

    // _input = await jsonRender.pass(options, _input, ["name", "class", "icon", "style"]);
  } catch (error) {
    // console.log(`ua.input Error: ${error}`);
  }

  // console.log("*** Opt 2", JSON.stringify([options, _input], null, 2));

  // console.log("Input", {input, options});

  if ("inputclass" in options) {
    _input.class += " " + options.inputclass;
  }

  // console.log("*** Opt 3", JSON.stringify([options, _input], null, 2));

  if ("inputstyle" in options) {
    _input.style = options.inputstyle;
  }

  //   console.log("*** Opt 4", JSON.stringify([options, _input], null, 2));

  // console.log("*** Opt 5", JSON.stringify([options, _input], null, 2));


  var element = {
    "n": "div",
    "name": options.name,
    "c": "form-group pb-3",
    "i": [{
      "n": "label",
      "for": randomName,
      "c": "pb-2 fs-4",
      "i": options.title
    }, {
      "n": "div",
      "c": "input-group",
      "i": ""
    }]
  }

  // console.log("*** Opt 6", JSON.stringify([options, _input], null, 2));

  //if icon is provided
  if ("icon" in options) {
    element.i[1].i = [{
      "n": "div",
      "c": "input-group-prepend",
      "i": [{
        "n": "div",
        "c": "input-group-text rounded-0 rounded-start input-icon-block",
        "i": [{
          "n": "i",
          "class": options.icon
        }]
      }]
    }, _input];
  } else {
    element.i[1].i = _input;
  }

  //add <div id="passwordHelpBlock" class="form-text">${options.description}</div>/*
  if ("description" in options) {
    element.i.push({
      "n": "div",
      "id": `${randomName}-description`,
      "c": "form-text",
      "i": options.description
    });
  }

  // console.log("*** Opt 7", {options, _input});

  // console.log("ua.input Sending an element", JSON.stringify([element, options], null, 2));

  var domElement = await jsonRender.render(element);
  var input = domElement.querySelector("input");
  input.addEventListener("focus", myfocus);
  input.addEventListener("focusout", myfocus);
  input.setAttribute("international", options.international);

  return domElement;

}

async function myfocus(event) {
  // console.log("focus", event);

  //if the phone has a (), -, or space, remove it
  this.value = this.value.replace(/[\(\)\-\s]/g, "");

  // if the phone number has 10 digits and doesn't start with a +, add a +1
  if (this.value.length == 10 && this.value[0] != "+") {
    this.value = "+1" + this.value;
  }

  this.classList.remove("is-invalid");
  this.classList.remove("is-valid");

  //if the input is not empty
  if (this.value.trim() != "") {

    //get the parent uae element
    var parent = this.closest("uae");
    var errors = validate(parent);

    if (errors.length > 0) {
      parent.classList.add("is-invalid");
      this.classList.add("is-invalid");
    } else {
      parent.classList.add("is-valid");
      this.classList.add("is-valid");
    }

  } else {
    this.value = "+1";
  }
}

/**
 * Saves the code from the iframe.
 * Called by UATools.
 * @param {*} name The name of the control.
 * @param {*} control The control to save.
 * @param {*} repo The repo (used to send back), with the prevalidation results.
 * @property {*} repo.success The success object (is this field ready to be saved).
 * @property {*} repo.data The actual data object that will be saved. JSON encodable only (no functions or promises).
 * @property {*} repo.errors The error's applied to the object. Should be an array, can have more than one item.
 * @property {*} repo.errors.input If appliable, the direct input that caused the erorr - it must be an object. If input is not provided the control will be highlighted.
 * @property {*} repo.errors.input.id The id of the input field, if applicable.
 * @property {*} repo.errors.input.name The name of the input field if applicable.
 * @property {*} repo.errors.type The type of error that occured.
 *  - Supports: "validation" - The input or field or control is invalid
 *  - Supports: "thowable" - Processing this field caused a throwable to error out.
 * @property {*} repo.errors.message The message to display to the user.
 * @returns The repo object with the data to save
 */
async function save(name, control, repo) {

  // console.log("Starting save", {
  //   control, repo
  // });

  repo.errors = validate(control);
  if (repo.errors.length > 0) {
    repo.success = false;
  }


  //get the input from the control and check if it's valid
  var input = control.querySelector("input");
  repo.data = input.value;

  return repo;

} module.exports.save = save;

function validate(control) {
  //get the input from the control
  var input = control.querySelector("input");

  var errors = [];

  if (!(input.checkValidity())) {
    errors.push({
      type: "validation",
      message: input.validationMessage
    });
  } else {

    var international = input.getAttribute("international");
    // console.log("International", international);

    if (international === "true") {
      // console.log("International Phone");
      // if (!(sanitize.phone(input.value))) { 

      var isrequoired = input.getAttribute("required");

      if (!(isrequoired)) {

        //if the iput is empty, or +1, than don't validate
        if (input.value.trim() == "" || input.value.trim() == "+1") {
          return errors;
        }

      }

      if (!(sanitize.phone(input.value))) {

        //trim if it's a +1 and nothing else remove it
        if (input.value.trim() == "+1") {
          input.value = "";
        } else {
          errors.push({
            type: "phone",
            message: "A phone number must be entered in the format +11234567890, which includes a country code and area code. Please don't include any dashes, spaces, or parentheses."
          });
        }
      }

    } else {
      // console.log("US Phone");
      if (!(sanitize.phone_US(input.value))) {
        errors.push({
          type: "phone_us",
          message: "A phone number must be entered in the format +11234567890. Please don't include any dashes, spaces, or parentheses. This field does not accept international numbers."
        });

      }
    }
  }

  // console.error("Phone Errors", errors);

  return errors;

}

/**
 * Loads the control with data.
 * @param {*} name The name of the control.
 * @param {*} control The control itself (including placeholder tag).
 * @param {*} data The data to load into the control.
 */
async function load(name, control, data) {

  //get the input from the control
  var input = control.querySelector("input");

  //if the value is blank or a +1 do not set it
  if (data.trim() === "" || data.trim() === "+1") {
    // console.log("Not setting value", data);
    return;
  }

  //set the value
  input.value = data;

} module.exports.load = load;